import styled from "styled-components/macro";

import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";
import classNames from "classnames";

import { EditorTypography } from "UI/FnrTextEditor/EditorTypography";

import "./CustomMessageContainerQueries.scss";
import Image from "./Image";
import NetworkInfo from "./NetworkInfo";
import PublicFundList from "./PublicFundList";
import Video from "./Video";

export default function CustomMessageColumn() {
  const { state } = useManageMyGivingPage();
  const { description, videoURL, imageURL } = state.pageSettings;
  const network = state.network;

  return (
    <CustomMessageContainer
      className={classNames("custom_message_container", {
        has_video: videoURL,
        has_image: imageURL,
        has_descrip: description,
      })}
    >
      <CustomMessageInside className="custom_message_inside">
        <NetworkInfo {...network} />
        {description && (
          <MessageText
            className="custom_message_text"
            dangerouslySetInnerHTML={{
              __html: description,
            }}
          />
        )}

        {videoURL ? (
          <Video url={videoURL} />
        ) : imageURL ? (
          <Image url={imageURL} />
        ) : null}

        <PublicFundList />
      </CustomMessageInside>
    </CustomMessageContainer>
  );
}

export const CustomMessageContainer = styled.div`
  box-sizing: border-box;
  padding: 60px 0;
  font-size: 18px;
  font-weight: 400;
  width: 100%;
  margin: 0 auto;
  color: var(--textPrimary);
  box-sizing: border-box;
  &.has_descrip.has_video,
  &.has_descrip.has_image {
    display: flex;
    align-items: center;
    justify-content: stretch;
    min-height: 40vh;
  }
`;
const CustomMessageInside = styled.div``;

const MessageText = styled(EditorTypography)`
  grid-area: descrip;
  order: 4;
  @media (max-width: 1000px) {
    padding-top: 16px;
  }
`;
